import counterfeitReportMdl from "./counterfeitReport.mdl";

export default [...counterfeitReportMdl];
